import { Box, Container, Typography } from '@mui/material'
import React from 'react'
import warning from './warning.png';
import { MotionClone } from '../../Components/MotionClone';
import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';
import { useNavigate } from 'react-router-dom';

export default function ErrorPage() {
    const navigate = useNavigate();

    return (
        <div style={{ backgroundColor: 'rgba(255, 173, 102, 0.7)', width: '100%', height: '100%', minHeight: '100vh', display: 'flex', justifyContent: 'center', alignContent: 'center', alignItems: 'center' }}>
            <Container maxWidth="md" sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignContent: 'center', alignItems: 'center', pb: '160px' }}>
                <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, mt: '40px', justifyContent: 'center', alignContent: 'center', alignItems: 'center' }}>
                    <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignContent: 'center', alignItems: 'center' }}>
                        <Typography sx={{ fontSize: '108px', lineHeight: '108px', fontWeight: 700, color: 'white' }}>
                            404
                        </Typography>
                        <Typography sx={{ fontSize: '30px', color: 'white' }}>
                            Page not found
                        </Typography>
                    </Box>
                    {/*<Box component={'img'} src={warning} sx={{ maxHeight: '170px', maxWidth: '170px', ml: { xs: '0px', sm: '60px' }, mt: { xs: '42px', sm: '0px' } }} />*/}
                </Box>
                <MotionClone scale={1.02}>
                    <Box sx={{
                        bgcolor: 'white', borderRadius: '12px',
                        display: 'flex', flexDirection: 'row', alignContent: 'center', alignItems: 'center', cursor: 'pointer',
                        mt: '84px', minWidth: '200px'
                    }} onClick={() => {
                        navigate("/");
                    }}>
                        <ArrowBackIosRoundedIcon sx={{ color: 'rgba(255, 173, 102, 0.7)', ml: '8px', width: '24px', height: '24px', mr: '-24px' }} />
                        <Typography sx={{ color: 'rgba(255, 173, 102, 0.7)', fontWeight: 'bold', py: '8px', mx: 'auto' }}>
                            Go Home
                        </Typography>
                    </Box>
                </MotionClone>
            </Container>
        </div>
    )
}
